// src/components/AboutMe.js
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./css/AboutMe.css";
import ConfirmationModal from "../components/ConfirmationModal";

const AboutMe = () => {

  const formRef = useRef();
  const [status, setStatus] = useState(null);

  const sendEmail = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch("https://website-backend-production-2163.up.railway.app/api/email/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        setStatus("success");
        formRef.current.reset();
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setStatus("error");
    }
  };



  return (
    <div className="about-me">
      <div class="header">
      <Link to="/" className="home-button">⟵ Home</Link>
      </div>
      

      <div className="profile-container">
        <div className="left-column glass-card">
          <h1 className="page-title">About Me</h1>
          <img
            src="/White3DKeycapFNNoBackground.png"
            alt="Felippe"
            className="profile-img"
          />
          <p className="firstBox">
            Hi there! I'm Felippe, a passionate game developer with a strong focus on creating
            interactive and immersive experiences. I've been working with various technologies,
            including <strong>C#</strong>, <strong>Java</strong>, and <strong>Python</strong>, and I love bringing my ideas to life through
            coding and design.
          </p>
          <p className="secondBox">
            Over the years, I've gained experience in both backend and frontend development,
            creating applications that engage users and provide seamless interactions. I’m
            particularly skilled in game mechanics, player movement, and AI systems. I'm always
            eager to explore new areas, learn more, and challenge myself with exciting projects.
          </p>
          <div className="ways-contact">
            <a href="https://github.com/Felippefn" target="__blank" className="icon-github"><i className="bi bi-github"></i></a>
            <a href="https://www.linkedin.com/in/felippefn/" target="__blank" className="icon linkedin"><i className="bi bi-linkedin"></i></a>
            <a href="mailto:flppprojects@outlook.com" className="icon email"><i className="bi bi-envelope-fill"></i></a>
            <a href="https://discordapp.com/users/330511498352918529" className="icon discord"><i className="bi bi-discord"></i></a>
          </div>
        </div>

        <div className="right-column glass-card">
          <h2>🔥 What Drives Me</h2>
          <p>
            I’m driven by curiosity and the challenge of building meaningful software. Whether it’s
            crafting smooth UI/UX or designing a combat system, I’m all in on clean, scalable code.
          </p>

          <h2 className="skills-title">🧠 Skills & Technologies</h2>
          <ul className="skills-list">
            <li><strong>Game Dev:</strong> Unity, C#</li>
            <li><strong>Web:</strong> React, Node.js, Angular</li>
            <li><strong>Backend:</strong> Java (Spring Boot), .Net (ASP.NET)</li>
            <li><strong>Databases:</strong> MongoDB, PostgreSQL</li>
            <li><strong>Tools:</strong> Git, Docker, Figma, Linux</li>
          </ul>
        </div>
      </div>
    <div style={{paddingTop: '150px'}}>
        <div className="contact-form-box">
                      <h3>Send me a message</h3>
                      <form ref={formRef} className="contact-form" onSubmit={sendEmail}>
                          <input type="text" name="name" placeholder="Your Name" required />
                          <input type="email" name="user_email" placeholder="Your Email" required />

                          <select name="reason" required>
                              <option value="">Select Reason</option>
                              <option value="Ask for a service">Ask for a service</option>
                              <option value="General contact">General contact</option>
                              <option value="Feedback">Feedback</option>
                          </select>

                          <textarea name="message" placeholder="Describe your message..." rows="5" required></textarea>

                          <button type="submit">Send Message</button>
                      </form>
                  </div>
                  </div>

      <footer className="footerAbout">
        © {new Date().getFullYear()} fn-studios. All rights reserved.
      </footer>

      <ConfirmationModal
        status={status}
        onClose={() => setStatus(null)}
        onContinue={() => setStatus(null)}
      />
    </div>
  );
};

export default AboutMe;
